import { logger } from '@empathybroker/ebx-gluon';
import Vue from 'vue';

export function registerComponents() {
  const components = require.context('../../components/', true, /\.(vue|ts)$/i);
  const componentNames: string[] = [];
  components.keys().forEach(componentFileRoute => {
    const fileNameStartIndex = componentFileRoute.lastIndexOf('/') + 1;
    const fileNameEndIndex = componentFileRoute.lastIndexOf('.');
    const fileName = componentFileRoute.substring(fileNameStartIndex, fileNameEndIndex);
    const name = kebabCaseToCamelCase(fileName);
    componentNames.push(name);
    Vue.component(name, components(componentFileRoute).default);
  });
  logger.info('[Custom Component]', componentNames);
}

function kebabCaseToCamelCase(str: string): string {
  return str.split('-')
    .map(string => `${ string.charAt(0).toUpperCase() }${ string.slice(1) }`)
    .join('');
}
